import AppleStoreButton from 'assets/images/getVaroApp/AppleStoreIcon.svg';
import GooglePlayButton from 'assets/images/getVaroApp/GooglePlayIcon.svg';
import qrCodeImage from 'assets/images/getVaroApp/varo-app-qr-code.png';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Image,
  ImageSourcePropType,
  Linking,
  StyleSheet,
  View,
} from 'react-native';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleXLText from 'shared/components/vxl/typography/primary/title/TitleXLText';
import {
  ANDROID_APP_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
} from 'shared/constants/appStore';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import theme from 'shared/styles/theme';

import SVGButton from './components/SVGButton';

const GetVaroApp = () => {
  const { t: translatedText } = useTranslation('getVaroApp');

  useViewDidFocusScreenAnalyticsEvent({
    key: '/get-varo-app/appDownloadQrCode',
  });

  return (
    <View style={styles.container}>
      <TitleXLText>{translatedText('heading')}</TitleXLText>
      <BodyBaseText style={styles.subTitle}>
        {translatedText('subTitle')}
      </BodyBaseText>
      <BodyBaseBoldText style={styles.description}>
        {translatedText('description')}
      </BodyBaseBoldText>

      <View style={styles.bodyContent}>
        <View style={styles.appStoreContainer}>
          <View style={styles.qrCodeContainer}>
            <Image
              source={qrCodeImage as ImageSourcePropType}
              style={styles.image}
              role="img"
              accessible
              resizeMode="contain"
            />
          </View>
          <View style={styles.appStoreButtonsContainer}>
            <SVGButton
              SVGComponent={<AppleStoreButton />}
              onPress={() => Linking.openURL(IOS_APP_STORE_URL)}
              testID="apple-store-button"
              analyticsId="storeClicked"
              customAttributes={{
                store_selected: 'app_store',
              }}
            />
            <SVGButton
              SVGComponent={<GooglePlayButton />}
              onPress={() => Linking.openURL(ANDROID_APP_PLAY_STORE_URL)}
              testID="google-play-button"
              analyticsId="storeClicked"
              customAttributes={{
                store_selected: 'google_play',
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default GetVaroApp;
const styles = StyleSheet.create({
  appStoreButtonsContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.m,
  },
  appStoreContainer: {
    alignItems: 'center',
    backgroundColor: theme.color.background.surface,
    borderRadius: theme.spacing.xs,
    gap: theme.spacing.xxl,
    justifyContent: 'center',
    paddingVertical: 64,
  },
  bodyContent: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    padding: theme.spacing.m,
  },
  description: {
    marginBottom: theme.spacing.xl,
    marginTop: theme.spacing.l,
  },
  image: { flex: 1, height: '100%', width: '100%' },
  qrCodeContainer: {
    alignItems: 'center',
    height: 139,
    justifyContent: 'center',
    width: 139,
  },
  subTitle: {
    marginTop: theme.spacing.m,
  },
});
